import { Layout } from 'antd';
import clsx from 'clsx';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

const { Content } = Layout;

function PageLayout({ children = {}, className = '', body_classname = '' }) {
  return (
    <Layout
      className={clsx(className)}
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />

      <Content>
        <Layout
          className={clsx('h-100', body_classname)}
          style={{
            // backgroundColor: '#fff',
            paddingLeft: 36,
            paddingRight: 36,
            paddingTop: 36,
            paddingBottom: 36,
            margin: '0 auto',
          }}
        >
          {children}
        </Layout>
      </Content>

      <Footer />
    </Layout>
  );
}

export default PageLayout;
